import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "isAppOnline": true
}
const appOnlineStatus = createSlice({
    name:'appOnlineStatus',
    initialState,
    reducers:{
        addAppOnlineStatus: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "isAppOnline": payload.payload
               }
        }
    }
});

export default appOnlineStatus.reducer
export const addAppOnlineStatus = appOnlineStatus.actions.addAppOnlineStatus